import axios from "./axios"

export const register = async (params) => {
  try {
    return await axios.post(`/auth/register`, params)
  } catch (error) {
    throw error.response.data.message
  }
};